// extracted by mini-css-extract-plugin
export default {"main":"DetailLayout_main__iCysf","body":"DetailLayout_body__Omxih"};